module.exports = __webpack_public_path__ + "static/img/code.2bb5700.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online_service/code.png
// module id = y/IK
// module chunks = 1